module.exports = __webpack_public_path__ + "img/HMP_COLOR.b3abdc4e.svg";